import border from 'assets/svg/black-line.svg';
import logo from 'assets/svg/logo.svg';
import successImage from 'assets/svg/success.svg';
import errorImage from 'assets/svg/error.svg';

import matManLoader from 'assets/images/mat-man-loader.png';
import appSplashLanguage from 'assets/images/appSplash/splash_language.png';
import appSplashNumbers from 'assets/images/appSplash/splash_numbers_portrait.png';
import appSplashNumbersLandscape from 'assets/images/appSplash/splash_numbers_landscape.png';

const { REACT_APP_S3_PREFIX } = process.env;

const assets = {
  audio: {
    application: {
      chooseApplicationSound: `${REACT_APP_S3_PREFIX}/audio/choose-an-application.mp3`
    }
  },

  images: {
    border,
    logo,
    matManLoader,
    appSplashLanguage,
    appSplashNumbers,
    appSplashNumbersLandscape,
    successImage,
    errorImage
  }
};

export default assets;
